import React from 'react'

import styles from './index.module.less'

export interface IPreProps extends React.HTMLAttributes<HTMLPreElement> {
  noWrap?: boolean
}

export default function Pre({
  noWrap,
  className,
  children,
  ...rest
}: IPreProps) {
  return (
    <pre
      className={`${styles.pre} ${className} ${noWrap ? styles.preNoWrap : ''}`}
      {...rest}
    >
      {children}
    </pre>
  )
}
